"use client";

import React from "react";
import { ArrowRight, Eye } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
const products = [{
  id: "prod-1",
  title: "Furniture Removal",
  description: "Efficient removal of old sofas, tables, and bulky items from your home or office.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/furniture_removal_service.png"
}, {
  id: "prod-2",
  title: "Appliance Removal",
  description: "Safe disposal of refrigerators, washers, and dryers with eco-friendly recycling.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/appliance_disposal_hauling.png"
}, {
  id: "prod-3",
  title: "Mattress Disposal",
  description: "Hassle-free mattress and box spring removal to keep your space clean and clear.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/mattress_removal_recycling.png"
}, {
  id: "prod-4",
  title: "Garage Cleanouts",
  description: "Complete clearing of cluttered garages, sheds, and storage units in one visit.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/garage_cleanout_junk.png"
}, {
  id: "prod-5",
  title: "Renovation Debris",
  description: "Post-construction cleanup including drywall, flooring, and general building waste.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/renovation_debris_cleanup.png"
}, {
  id: "prod-6",
  title: "Yard Waste Removal",
  description: "Clearing branches, leaves, and landscaping debris to restore your outdoor space.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/yard_waste_hauling.png"
}];
export default function ServicesGrid() {
  return <section data-section-id="223087" id="services-grid" className="bg-background py-24 px-6 md:px-12 lg:px-24 text-foreground">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-4 tracking-tight">
            Our Junk Removal Services
          </h2>
          <Separator className="w-24 mx-auto bg-secondary h-1 rounded-md" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, i) => <div key={product.id} data-index={i} className="group relative h-full">
              <Card className="rounded-lg shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden border-border/40 h-full flex flex-col bg-card">
                <div className="relative overflow-hidden">
                  <AspectRatio ratio={16 / 9}>
                    <img src={product.image} alt={product.title} className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-105" />
                  </AspectRatio>
                  
                  {}
                  <div className="absolute inset-0 bg-primary/20 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <Button variant="secondary" className="rounded-md shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 ease-out bg-secondary text-secondary-foreground hover:bg-secondary/90">
                      <Eye className="w-4 h-4 mr-2" />
                      Service Details
                    </Button>
                  </div>
                </div>
                
                <CardHeader className="flex-grow pt-6 pb-8">
                  <CardTitle className="font-default font-bold text-xl text-foreground mb-2">
                    {product.title}
                  </CardTitle>
                  <CardDescription className="font-default text-muted-foreground text-base leading-relaxed">
                    {product.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            </div>)}
        </div>

        <div className="mt-20 flex flex-col items-center">
          <Separator className="w-full max-w-md mb-8 bg-border/60" />
          <Link to="/PricingPage" className="inline-flex items-center text-primary font-default font-bold text-lg hover:text-secondary transition-colors group">
            View Full Pricing & Services
            <ArrowRight className="ml-2 w-5 h-5 transform group-hover:translate-x-1.5 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>;
}